import { TenantSettingsExpanded } from "../tenant/dto";

export interface NotificationDto {
    id: number;
    tenantId?: number;
    userId?: number;
    notificationType: NotificationType;
    notificationDetails: NotificationDetails;
    createdAt: Date;
}

export enum NotificationType {
  TENANT_UPDATED = 'TENANT_UPDATED',
  EMPLOYEE_REMAINING_BALANCE_UPDATED = 'EMPLOYEE_REMAINING_BALANCE_UPDATED',
  APPLICATION_PENDING_APPROVAL = 'APPLICATION_PENDING_APPROVAL',
  APPLICATION_INVOICE_ISSUED = 'APPLICATION_INVOICE_ISSUED',
  TENANT_PENDING_APPROVAL = 'TENANT_PENDING_APPROVAL',
  APPLICATION_CANCELLED = 'APPLICATION_CANCELLED',
}

interface NotificationDetailsDto {
    id: string;
}

export interface EmployeeRemainingBalanceUpdatedNotificationDetailsDto extends NotificationDetailsDto {
  amount: number;
}

export interface ApplicationPendingApprovalNotification
  extends NotificationDetailsDto {
  firstName: string;
  lastName: string;
  applicationNumber: string;
}

export interface ApplicationInvoiceIssuedNotification
  extends NotificationDetailsDto {
  tenantName: string;
  invoiceNumber: string;
}

export interface TenantPendingApprovalNotification extends NotificationDetailsDto {
  tenantName: string;
  accountNumber: string;
}

export interface ApplicationCancelledNotification extends NotificationDetailsDto {
  applicationNumber: string;
  cancellationReason?: string;
}

export interface TenantWasUpdatedNotificationDto
  extends NotificationDetailsDto {
  addedFields: Partial<TenantSettingsExpanded>;
  updatedFields: Partial<TenantSettingsExpanded>;
  deletedFields: Partial<TenantSettingsExpanded>;
  tenant: {
    tenantId: number;
    tenantName: string;
  };
}

export type NotificationDetails =
    | TenantWasUpdatedNotificationDto
    | EmployeeRemainingBalanceUpdatedNotificationDetailsDto
    | ApplicationPendingApprovalNotification
    | ApplicationInvoiceIssuedNotification
    | TenantPendingApprovalNotification
    | ApplicationCancelledNotification;
